import React, { FC, useState, useRef, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getErrorMessage } from '../../../../utils/errorMessage';
import { FOLDER_TITLE_LIMIT } from '../../../../utils/constants';
import styles from './create_folder_form.module.scss';
import { PrimaryButton } from '../../../../components/button';
import { InputText } from '../../../../components/input/input-text/InputText';

type Props = {
  onFolderCreate: ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => void;
};

export const CreateFolderForm: FC<Props> = ({ onFolderCreate }) => {
  const [title, setTitle] = useState('');
  const [errorMessage, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const intl = useIntl();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    setTitle(value);
    if (errorMessage) {
      setError('');
    }
  };

  const onSubmit = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    if (inputRef && inputRef.current) {
      setIsSubmitting(true);
      try {
        await onFolderCreate({
          title: title.trim(),
          source: 'createAndAddDecision',
        });
      } catch (error) {
        if (error.response) {
          setError(getErrorMessage(error.response, intl.formatMessage));
        }
      }
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className={styles.group}>
        <InputText
          ref={inputRef}
          className={styles.input}
          placeholder="Nom du dossier"
          maxLength={FOLDER_TITLE_LIMIT}
          id="new-folder"
          value={title}
          onChange={onChange}
        />

        <PrimaryButton
          type="submit"
          id="validate-new-folder"
          disabled={isSubmitting || title.length === 0}
        >
          <FormattedMessage id="folders/create/CreateFolderForm.tsx/1" />
        </PrimaryButton>
      </div>
      {errorMessage && (
        <div className={`form-error is-visible ${styles.error}`}>
          {errorMessage}
        </div>
      )}
    </form>
  );
};
